<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    :class="{ 'properties-field-group': isGroup }"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">
          Properties
          <div class="title-badge">Column</div>
        </h4>
        <div
          class="close-properties"
          @click="closeConfiguration"
        >
          &times;
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content properties-field-content-config">
        <div class="section-field input-field">
          <!-- Name Section -->
          <b-form :class="{'error-input' : $v.dataSetup.name.$error}">
            <label> Name </label>
            <j-input
              v-model="dataSetup.name"
              placeholder="Enter column name"/>
          </b-form>

          <!-- Format Section -->
          <b-form :class="{'error-input' : $v.dataSetup.type.$error}">
            <label> Format </label>
            <j-single-select
              v-model="dataSetup.type"
              :custom="true"
              :options="isDatasetSource ? formatDatasetOptions : formatOptions"
              placeholder="Select format"
            >
              <template
                slot-scope="node"
                slot="node-custom"
              >
                <img
                  :src="require(`@/assets/icon/column-type/${setIconType(node.node.id)}.svg`)"
                  style="width:14px;height:auto;margin-right:5px;"> {{ node.node.label }}
              </template>
            </j-single-select>
          </b-form>

          <!-- Timezone field -->
          <b-form
            v-if="dataSetup.type === 'datetime' ||
              dataSetup.type === 'time' ||
              dataSetup.type === 'dd-mmm-yyyy' ||
              dataSetup.type === 'mmmm dd, yyyy' ||
              dataSetup.type === 'MMMM dd, yyyy'
            "
          >
            <label> Timezone </label>
            <j-single-select
              v-model="dataSetup.timezone"
              :options="listTimezone"
              :placeholder="'Select Timezone'"
              label="text"
              value-format="object"
            />
          </b-form>

          <!-- Parse Variable Section -->
          <hr v-if="dataSetup.type !== 'action_button'">
          <h4
            v-if="dataSetup.type !== 'action_button'"
            class="title-section">Parse Value To</h4>
          <b-form
            v-if="dataSetup.type !== 'action_button'"
            :class="{'error-input' : $v.dataSetup.key.$error}">
            <label> Column </label>
            <j-single-select
              v-model="dataSetup.key"
              :options="variableOptionsFiltered"
              :placeholder="'Select variable'"
              :disabled="!dataSetup.type"
            />
          </b-form>
        </div>

        <!-- Action Button -->
        <div
          v-if="dataSetup.type === 'action_button'"
          class="section-field input-field">
          <h4 class="title-section">Action Button</h4>

          <div
            v-for="(item, index) in dataSetup.action_buttons"
            :key="index"
            class="container-action-button-table">
            {{ item.label }}
            <i
              class="fa fa-lg fa-trash pull-right cursor-pointer"
              @click="deleteActionButton(index, true)"/>
            <i
              class="fa fa-lg fa-pencil-square-o pull-right cursor-pointer m__t--1"
              @click="openConfigActionButton(item, index)"/>
          </div>

          <div
            class="btn-add-config"
            @click="openConfigActionButton(null, null)">
            + Add Action Button
          </div>
        </div>

        <!-- Configuration Section -->
        <div
          v-if="dataSetup.type !== 'action_button'"
          class="section-field input-field">
          <h4 class="title-section">Configuration</h4>

          <!-- Timezone field -->
          <b-form v-if="dataSetup.type === 'text' && parseValueTimer && type !== 'export'">
            <label> Timezone </label>
            <j-single-select
              v-model="dataSetup.timezone"
              :options="listTimezone"
              :placeholder="'Select Timezone'"
              label="text"
              value-format="object"
            />
          </b-form>

          <!-- Filter -->
          <div
            v-if="type === 'export' && useFilter"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Show as search column result</h4>
                <h4 class="configuration-section-desc mb-0">This column will be displayed on the table of the search results</h4>
              </div>
              <j-switch v-model="dataSetup.is_filter"/>
            </div>
          </div>

          <!-- Sorting -->
          <div
            v-else-if="useFilter"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title mb-0">Sort</h4>
              </div>
              <j-switch v-model="dataSetup.sort"/>
            </div>
          </div>

          <!-- Content Alignment -->
          <div
            v-if="dataSetup.type !== 'progress_bar'"
            class="configuration-section">
            <h4 class="configuration-section-title">Content Alignment</h4>
            <p class="configuration-section-desc">
              Where and how the text lines up
            </p>

            <div class="wrap-alignment">
              <div
                v-for="align in contentAlignment"
                :key="align.type"
                :class="{'alignment-active': dataSetup.content_alignment === align.type}"
                class="alignment-block"
                @click="changeAlignment(align.type)"
              >
                <img
                  v-if="dataSetup.content_alignment !== align.type"
                  :src="require(`@/assets/icon/column-alignment/${align.type}.svg`)"
                  :alt="`align-${align.type}`"
                >
                <img
                  v-else
                  :src="require(`@/assets/icon/column-alignment/${align.type+'-blue'}.svg`)"
                  :alt="`align-${align.type}`"
                >
              </div>
            </div>
          </div>

          <!-- Allow Minus Value Properties -->
          <div
            v-if="dataSetup.type === 'currency'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Allow Minus Value</h4>
                <p class="configuration-section-desc">
                  Show currency in brackets as minus value sign
                </p>
              </div>
              <j-switch v-model="dataSetup.allow_minus_value" />
            </div>
          </div>

          <!-- Default Currency -->
          <div
            v-if="dataSetup.type === 'currency'"
            class="configuration-section"
          >
            <b-form :class="{'error-input' : $v.dataSetup.default_currency.$error}">
              <label> Default Currency </label>
              <j-single-select
                v-model="$v.dataSetup.default_currency.$model"
                :options="list_currency"
                label="symbol_name"
                placeholder="Select Default Currency" />
            </b-form>
            <div class="field-information">
              The default currency is the value currency specified in the field value attribute
            </div>
          </div>

          <!-- Color progress Bar -->
          <div
            v-if="dataSetup.type === 'progress_bar'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Color</h4>
            <p class="configuration-section-desc">
              Custom appearance for progress bar
            </p>

            <j-color-picker
              v-model="dataSetup.color"
              :color="dataSetup.color"
              label="Color"
              picker="chrome"
            />
          </div>

          <!-- Editable -->
          <div
            v-if="type === 'table_view' && isUseEditable"
            class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Editable</h4>
                <p class="configuration-section-desc">
                  Allow edit action and update data in table column
                </p>
              </div>
              <j-switch v-model="dataSetup.is_editable_column"/>
            </div>

            <div v-if="dataSetup.is_editable_column">
              <div
                v-if="!dataSetup.editable_column"
                class="btn-add-config"
                @click="openModalFieldLibrary"
              >
                + Add Field
              </div>

              <div
                v-else
                :class="{'selected': showProperties}"
                class="field-list mb-0"
              >
                <p class="column-name">{{ dataSetup.editable_column.name || 'Field Name' }}</p>
                <field-preview
                  :column="dataSetup.editable_column"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="editField"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteField"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Direct Open Detail Properties -->
          <div
            v-if="dataSetup.type === 'text' && variableType === 'object'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Direct Open Detail</h4>
                <p class="configuration-section-desc">
                  Show currency in brackets as minus value sign
                </p>
              </div>
              <j-switch v-model="dataSetup.is_use_direct_open_detail" />
            </div>
            <b-form
              v-if="dataSetup.is_use_direct_open_detail"
              :class="{'error-input' : $v.dataSetup.form_ui_id.$error}"
            >
              <label> Experience Manager</label>
              <j-single-select
                v-model="dataSetup.form_ui_id"
                :load-options="loadOptionsFormUI"
                :is-async="true"
                :cache-option="false"
                :placeholder="'Experience Manager'"
                value-format="object"
                label="name"
              />
            </b-form>
          </div>
        </div>
      </div>

      <!-- Button Properties -->
      <div
        :class="{ 'justify-content-end': !fieldDetail }"
        class="properties-field-button"
      >
        <button
          v-if="fieldDetail"
          class="button-border"
          @click="deleteConfiguration"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="closeConfiguration"
          >
            Close
          </button>

          <button
            class="button-blue"
            @click="submitForm"
          >
            {{ fieldDetail ? 'Update' : 'Add' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Configuration Action Button -->
    <action-button-configuration
      v-if="isOpenConfigActionBtn"
      :id="idConfigActionBtn"
      :field-detail="selectedBtn"
      :on-table="true"
      :variable-options="variableOptions"
      :list-function="listFunction"
      @close-configuration="toggleConfigurationActionBtn(false)"
      @delete-action-button="deleteActionButton"
      @submit-configuration="submitActionButton"
    />

    <!-- Properties Field -->
    <properties-field
      v-if="showProperties"
      :ref="idProperties"
      :id="[idProperties]"
      :field-detail="dataSetup.editable_column"
      :is-group="true"
      :is-new-field="isNewField"
      :is-table-editable="true"
      @delete-field="deleteField"
      @close-properties="togglePropertiesField(false)"
      @submit-mode="submitField"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console, no-else-return, camelcase */
import { mapState, mapActions, mapMutations } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import jwtDecode from 'jwt-decode';
// Mixins
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jMixSetupActionButton from '@/mixins/form-ui-v2/jMixSetupActionButton';
// Components
import PropertiesField from '@/views/experience-manager-v2/partials/PropertiesField';
import ActionButtonConfiguration from '@/views/experience-manager-v2/partials//configuration/ActionButtonConfiguration';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
import jSwitch from '@/components/inputs/jSwitch';
import jColorPicker from '@/components/color-picker/jColorPicker';
// Data
import currency from '@/assets/file/currency.json';
import timezone from '@/assets/file/timezone.json';

export default {
  name: 'ColumnConfiguration',

  components: {
    PropertiesField,
    ActionButtonConfiguration,
    FieldPreview,
    jSwitch,
    jColorPicker,
  },

  mixins: [jMixAutoScroll, jMixSetupActionButton],

  props: {
    id: {
      type: String,
      default: '',
    },
    primaryKey: {
      type: String,
      default: '',
    },
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    selectVariable: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => '',
    },
    useFilter: {
      type: Boolean,
      default: true,
    },
    useAdditionalFormat: {
      type: Boolean,
      default: false,
    },
    isGroup: {
      type: Boolean,
      default: () => false,
    },
    actionButtons: {
      type: Array,
      default: () => [],
    },
    listFunction: {
      type: Array,
      default: () => [],
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    isDatasetSource: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isFirstLoad: true,
      dataSetup: {
        name: null,
        key: null,
        type: null,
        content_alignment: 'left',
        sort: false,
        is_filter: false,
        action_buttons: [],
        is_editable_column: false,
        editable_column: null,
        allow_minus_value: false,
        default_currency: null,
        timezone: null,
        is_use_direct_open_detail: false,
        form_ui_id: null,
        color: '#000000',
      },
      variableType: null,
      customField: null,

      // Field
      showProperties: false,
      idProperties: 'idPropertiesField',
      idModalFieldLibrary: 'modalFieldLibrary',
      isNewField: false,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),

      contentAlignment: [
        { type: 'left' },
        { type: 'center' },
        { type: 'right' },
      ],
      formatOptions: [
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'multiple_text',
          text: 'Multiple Text',
        },
        {
          id: 'currency',
          text: 'Currency',
        },
        {
          id: 'currency_selection',
          text: 'Currency Selection',
        },
        {
          id: 'datetime',
          text: 'Date Time',
        },
        {
          id: 'time',
          text: 'Time',
        },
        {
          id: 'dd-mmm-yyyy',
          text: 'Date (dd-mmm-yyyy)',
        },
        {
          id: `${this.type === 'export' ? 'MMMM' : 'mmmm'} dd, yyyy`,
          text: 'Date (mmmm dd, yyyy)',
        },
        {
          id: 'person',
          text: 'Person',
        },
        {
          id: 'multiple_attachment',
          text: 'Multiple Attachment',
        },
        {
          id: 'attachment',
          text: 'Attachment',
        },
        {
          id: 'action_button',
          text: 'Action Button',
        },
        {
          id: 'progress_bar',
          text: 'Progress Bar',
        },
      ],
      formatDatasetOptions: [
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'currency',
          text: 'Currency',
        },
        {
          id: 'datetime',
          text: 'Date Time',
        },
        {
          id: 'time',
          text: 'Time',
        },
        {
          id: 'dd-mmm-yyyy',
          text: 'Date (dd-mmm-yyyy)',
        },
        {
          id: `${this.type === 'export' ? 'MMMM' : 'mmmm'} dd, yyyy`,
          text: 'Date (mmmm dd, yyyy)',
        },
      ],
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', [
      'sourceModalFieldLibrary', 'showModalFieldLibrary',
    ]),

    variableOptionsFiltered() {
      if (this.dataSetup.type === 'currency' || this.dataSetup.type === 'progress_bar') {
        return this.selectVariable.filter(f => f.type === 'number' ||
        f.type === 'small_integer' ||
        f.type === 'integer' ||
        f.type === 'big_integer');
      } else if (this.dataSetup.type === 'currency_selection') {
        return this.selectVariable.filter(f => f.type === 'object');
      } else if (this.dataSetup.type === 'datetime' ||
                this.dataSetup.type === 'time' ||
                this.dataSetup.type === 'dd-mmm-yyyy' ||
                this.dataSetup.type === `${this.type === 'export' ? 'MMMM' : 'mmmm'} dd, yyyy`) {
        return this.selectVariable.filter(f => f.type === 'timestamp');
      } else if (this.dataSetup.type === 'attachment') {
        return this.selectVariable.filter(f => f.type === 'text' || f.type === '[]attachment');
      }
      return this.selectVariable.filter(f => f.type !== 'timestamp');
    },

    isUseEditable() {
      if (
        this.dataSetup.key === 'created_at' || this.dataSetup.key === 'updated_at' ||
        this.dataSetup.key === 'created_by' || this.dataSetup.key === 'updated_by' ||
        this.dataSetup.key === this.primaryKey || this.dataSetup.type === 'attachment' ||
        this.dataSetup.type === 'currency_selection' || this.dataSetup.type === 'progress_bar'
      ) {
        return false;
      } else {
        return true;
      }
    },

    list_currency() {
      const listKey = Object.keys(currency);
      const listValue = Object.values(currency);
      return listValue.map((e, index) => {
        e.id = listKey[index];
        e.symbol_name = `${e.symbol} - ${e.name}`;
        return e;
      });
    },

    listTimezone() {
      return timezone.map((zone) => {
        // eslint-disable-next-line no-param-reassign
        zone.id = zone.utc;
        return zone;
      });
    },

    parseValueTimer() {
      const findIndex = this.variableOptionsFiltered.findIndex(v => v.id === this.dataSetup.key);
      if (findIndex > -1) return this.variableOptionsFiltered[findIndex].type === 'timer';
      return false;
    },
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.type': function () {
      if (!this.isFirstLoad) {
        this.dataSetup.key = null;
        this.dataSetup.editable_column = null;
      }
    },

    // eslint-disable-next-line
    'dataSetup.key': function (val) {
      if (val) {
        this.variableType = this.variableOptionsFiltered.find(variable => variable.id === val).type;
      }
    },

    // eslint-disable-next-line
    'dataSetup.is_editable_column': function (val) {
      if (!val) this.dataSetup.editable_column = null;
    },

    showModalFieldLibrary(val) {
      const data = this.sourceModalFieldLibrary;
      if (!val) {
        if (data) {
          this.dataSetup.editable_column = data;
          this.isNewField = true;
          this.showProperties = true;
          this.customField = null;
          this.setSourceModalFieldLibrary(null);

          setTimeout(() => {
            this.togglePropertiesField(true);
          }, 100);
        } else {
          this.setCustomField(null);
          this.customField = null;
        }
      }
    },
  },

  created() {
    if (this.fieldDetail) {
      this.dataSetup = {
        key: this.fieldDetail.key,
        name: this.fieldDetail.name,
        type: this.fieldDetail.type,
        sort: this.fieldDetail.sort || false,
        is_filter: this.fieldDetail.is_filter || false,
        content_alignment: this.fieldDetail.content_alignment || 'left',
        action_buttons: [],
        is_editable_column: this.fieldDetail.config ? this.fieldDetail.config.is_editable_column : false,
        editable_column: this.fieldDetail.config ? this.fieldDetail.config.editable_column : null,
        default_currency: this.fieldDetail.config ? this.fieldDetail.config.default_currency : null,
        allow_minus_value: this.fieldDetail.config ? this.fieldDetail.config.allow_minus_value : false,
        timezone: this.fieldDetail.config && this.fieldDetail.config.timezone ? { ...this.fieldDetail.config.timezone, id: this.fieldDetail.config.timezone.utc } : null,
        is_use_direct_open_detail: this.fieldDetail.config && this.fieldDetail.config.direct_open_detail ?
          this.fieldDetail.config.direct_open_detail.is_use_direct_open_detail : false,
        form_ui_id: null,
        color: this.fieldDetail.config ? this.fieldDetail.config.color : '#000000',
      };
      if (this.fieldDetail.config) {
        // Set action button data
        if (this.fieldDetail.config.action_buttons) {
          this.fieldDetail.config.action_buttons.forEach((e) => {
            this.actionButtons.forEach((g) => {
              if (e === g.key) {
                this.dataSetup.action_buttons.push(g);
              }
            });
          });
        }

        if (this.fieldDetail.config.direct_open_detail && this.fieldDetail.config.direct_open_detail.form_ui_id) {
          const dataFilter = {
            id: this.fieldDetail.config.direct_open_detail.form_ui_id,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 5,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.findFormUi(reqData).then((res) => {
            const dataFormUi = res[0];
            dataFormUi.label = dataFormUi.name;
            this.dataSetup.form_ui_id = dataFormUi;
          });
        }
      }
    } else {
      this.dataSetup = {
        name: null,
        key: null,
        type: null,
        content_alignment: 'left',
        sort: false,
        is_filter: false,
        action_buttons: [],
        is_editable_column: false,
        editable_column: null,
        allow_minus_value: false,
        default_currency: null,
        is_use_direct_open_detail: false,
        form_ui_id: null,
        color: '#000000',
      };
    }

    if (!this.useAdditionalFormat) {
      // eslint-disable-next-line arrow-body-style
      this.formatOptions = this.formatOptions.filter((option) => {
        return option.id !== 'multiple_text' && option.id !== 'multiple_attachment';
      });
    }
    if (this.type === 'export') {
      this.formatOptions = this.formatOptions.filter(option => option.id !== 'attachment' && option.id !== 'action_button');
    }
    if (this.type === 'summary') {
      this.formatOptions = this.formatOptions.filter(option => option.id !== 'action_button');
    }
    if (process.env.DISABLE_CURRENCY_SELECTION === 'true') {
      this.formatOptions = this.formatOptions.filter(option => option.id !== 'currency_selection');
    }

    setTimeout(() => {
      this.isFirstLoad = false;
    }, 300);
  },

  methods: {
    ...mapActions('jStoreFormUi', ['findFormUi']),
    ...mapMutations('jStoreExperienceManagerV2', [
      'setShowModalFieldLibrary', 'setSourceModalFieldLibrary', 'setCustomField', 'setIsShowModalFieldFromGroup',
    ]),

    changeAlignment(alignment) {
      this.dataSetup.content_alignment = alignment;
    },

    setIconType(type) {
      const convertType = type.toLowerCase();
      let finalType = '';
      if (convertType === 'date' || convertType === 'mmmm dd, yyyy' || convertType === 'MMMM dd, yyyy' || convertType === 'dd-mmm-yyyy') {
        finalType = 'date';
      } else {
        finalType = convertType;
      }
      return finalType;
    },

    setDataCustomField() {
      if (this.variableType && this.isUseEditable) {
        switch (this.variableType) {
          case 'text':
            this.customField = [{
              fields: [
                { type: 'text', name: 'Text' },
                { type: 'descriptive', name: 'Text Area' },
                { type: 'single_selection', name: 'Single Selection' },
              ],
            }];
            break;
          case 'number':
            this.customField = [{
              fields: [
                { type: 'number', name: 'Number' },
                { type: 'number_decimal', name: 'Number (Decimal)' },
                { type: 'currency', name: 'Currency' },
              ],
            }];
            break;
          case '[]text':
            this.customField = [{
              fields: [
                { type: 'multiple_selection', name: 'Multiple Selection' },
              ],
            }];
            break;
          case 'timestamp':
            this.customField = [{
              fields: [
                { type: 'date', name: 'Date' },
                { type: 'date_time', name: 'Date Time' },
              ],
            }];
            break;
          case 'object':
            this.customField = [{
              fields: [
                { type: 'relation_record', name: 'Relation Record' },
                { type: 'relation_record_external_api', name: 'Relation Record External API' },
              ],
            }];
            break;
          case '[]object':
            this.customField = [{
              fields: [
                { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
                { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
              ],
            }];
            break;
          case 'tags':
            this.customField = [{
              fields: [
                { type: 'single_tags_selection', name: 'Single Tag' },
              ],
            }];
            break;
          case '[]tags':
            this.customField = [{
              fields: [
                { type: 'multiple_tags_selection', name: 'Multiple Tag' },
              ],
            }];
            break;
          case 'person':
            this.customField = [{
              fields: [
                { type: 'user_single_selection', name: 'User Selection' },
              ],
            }];
            break;
          default:
            this.customField = null;
            break;
        }

        this.setCustomField(this.customField);
      }
    },

    openModalFieldLibrary() {
      if (!this.dataSetup.key) {
        this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Select parse variable first');
      } else {
        this.setDataCustomField();
        this.setIsShowModalFieldFromGroup(true);
        this.setShowModalFieldLibrary(true);

        setTimeout(() => {
          const element = document.getElementById(this.idModalFieldLibrary);
          if (element) element.classList.add('show');
        }, 100);
      }
    },

    editField() {
      this.showProperties = true;
      this.togglePropertiesField(true);
    },

    // Open/close stacked properties
    togglePropertiesField(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idProperties);
          const elementParent = document.getElementById(this.id);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const element = document.getElementById(this.idProperties);
        const elementParent = document.getElementById(this.id);
        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.isNewField = false;
          this.showProperties = false;
        }, 200);
      }
    },

    deleteField() {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete field ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.editable_column = null;
          this.togglePropertiesField(false);
        }
      });
    },

    submitField(mode, params, isCancel) {
      if (params.field_ui_key) {
        if (!isCancel) {
          this.dataSetup.editable_column = params;
          this.togglePropertiesField(false);
        }
      } else {
        this.dataSetup.editable_column = null;
      }
    },

    submitForm() {
      const mode = this.fieldDetail ? 'edit' : 'add';

      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        if (this.type === 'export') {
          delete this.dataSetup.sort;
          if (!this.useFilter) delete this.dataSetup.is_filter;
        } else {
          delete this.dataSetup.is_filter;
        }
        if (this.dataSetup.type === 'action_button') {
          this.dataSetup.config = {
            action_buttons: this.dataSetup.action_buttons.map(el => (el.key)),
            is_editable_column: this.dataSetup.is_editable_column,
            editable_column: this.dataSetup.editable_column,
          };
        } else {
          this.dataSetup.config = {
            is_editable_column: this.dataSetup.is_editable_column,
            editable_column: this.dataSetup.editable_column,
          };
          if (this.dataSetup.type === 'currency') {
            this.dataSetup.config.allow_minus_value = this.dataSetup.allow_minus_value;
            this.dataSetup.config.default_currency = this.dataSetup.default_currency || 'IDR';
            this.dataSetup.config.symbol_default_currency = this.dataSetup.default_currency ? currency[this.dataSetup.default_currency].symbol : 'Rp';
            this.dataSetup.config.name_default_currency = this.dataSetup.default_currency ? currency[this.dataSetup.default_currency].name : 'Indonesia Rupiah';
          }
          if (
            (this.dataSetup.type === 'datetime' ||
              this.dataSetup.type === 'time' ||
              this.dataSetup.type === 'dd-mmm-yyyy' ||
              this.dataSetup.type === 'mmmm dd, yyyy' ||
              this.dataSetup.type === 'MMMM dd, yyyy'
            ) || (this.dataSetup.type === 'text' && this.parseValueTimer)
          ) {
            const timeZone = this.dataSetup.timezone || null;
            if (timeZone) {
              delete timeZone.id;
              delete timeZone.label;
            }
            this.dataSetup.config.timezone = timeZone;
          }
          if (this.variableType === 'object') {
            this.dataSetup.config.direct_open_detail = {
              is_use_direct_open_detail: this.dataSetup.is_use_direct_open_detail || false,
              form_ui_id: this.dataSetup.form_ui_id ? this.dataSetup.form_ui_id.id : '',
            };
          }
          if (this.dataSetup.type === 'progress_bar') {
            this.dataSetup.config.color = this.dataSetup.color;
            this.dataSetup.config.display_type = 'percentage';
          }
          delete this.dataSetup.editable_column;
          delete this.dataSetup.is_editable_column;
          delete this.dataSetup.allow_minus_value;
          delete this.dataSetup.default_currency;
          delete this.dataSetup.timezone;
          delete this.dataSetup.is_use_direct_open_detail;
          delete this.dataSetup.form_ui_id;
          delete this.dataSetup.color;

          if (this.type === 'export') {
            delete this.dataSetup.config.is_editable_column;
            delete this.dataSetup.config.editable_column;
          }
        }
        this.$emit('submit-configuration', mode, this.dataSetup);
      }
    },

    deleteConfiguration() {
      this.$emit('delete-configuration');
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          name: null,
          key: null,
          type: null,
          content_alignment: null,
          sort: false,
          is_filter: false,
          action_buttons: [],
          is_editable_column: false,
          editable_column: null,
          allow_minus_value: false,
          default_currency: null,
          is_use_direct_open_detail: false,
          form_ui_id: null,
          color: '#000000',
        };
      }, 400);
    },

    loadOptionsFormUI({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 100,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreFormUi/actionGetFormUiListAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        key: {
          required: requiredIf(() => this.dataSetup.type !== 'action_button'),
        },
        name: { required },
        type: { required },
        content_alignment: { required },
        allow_minus_value: {},
        default_currency: {},
        form_ui_id: {
          required: requiredIf(() => this.dataSetup.is_use_direct_open_detail),
        },
        color: {},
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrap-alignment {
    display: flex;
    align-items: center;

    .alignment-block {
      width: 47px;
      height: 33px;
      border: 1px solid #E7E7E7;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 7px;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
      img {
        width: 16px;
        height: auto;
      }
    }
    .alignment-active {
      border-color: #1A85E4;
      background-color:#F5FAFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/ColumnConfiguration.vue